export default __webpack_public_path__ + "static/media/Nav_Logo_White@3x.27f1d959.png";